import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import parkList from "./data/parkList-data.js";

const initVue = data => {
  const props = {
    ...data
  }

  createApp(App,props)
    .use(router)
    //add it public > index.html
    .mount("#parkList-app")
}

parkList.getParklist().then(initVue)
// parkList.getDescription().then(initVue)
//parkList.getParklist().then(data => {console.log(data)})